import * as React from 'react';

import {Body} from 'shells/typography/body';

import {useCreateNote} from '../../../core/graphql/hooks';

import {analyticsClient} from '../../../../analytics-client';

import {InteractionModalFooter} from '../interaction-modal-footer';
import type {LeadSummaryData} from '../types';

type Props = {
    data: LeadSummaryData;
    onCancel: () => void;
};

export function CreateLeadSummaryNotePage(props: Props) {
    const {createNote, isLoading} = useCreateNote();

    const handleCreateNote = () => {
        createNote({
            note: {
                value: props.data.note,
                entityId: props.data.entityId,
            },
        }).then(() => {
            $(window).trigger(Timeline.events.TimelineRefresh);
            analyticsClient.track(analyticsClient.EVENTS.TRACK_AI_ASSISTANT_LEAD_NOTE_ADDED);
            props.onCancel();
        });
    };

    return (
        <>
            <div className='overflow-auto border-box border br-3 pad-16 full-height'>
                <Body maintainLineBreaks={true}>{props.data.note}</Body>
            </div>
            <InteractionModalFooter
                onCancel={props.onCancel}
                onContinue={handleCreateNote}
                primaryButtonText='Add note'
                primaryButtonLoading={isLoading}
            />
        </>
    );
}
